import { Component, OnInit } from '@angular/core';
import { ExpenseModalComponent } from '../expense-modal/expense-modal.component';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { DatabaseService } from 'src/_services/DatabaseService';
import { DialogComponent } from 'src/app/dialog.component';
import { ImageModuleComponent } from 'src/app/image-module/image-module.component';
import { ExpesneEditComponent } from '../expesne-edit/expesne-edit.component';
import { sessionStorage } from 'src/app/localstorage.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import { StatusModalComponent } from 'src/app/order/status-modal/status-modal.component';

@Component({
  selector: 'app-detail-expense',
  templateUrl: './detail-expense.component.html',
  styleUrls: ['./detail-expense.component.scss']
})
export class DetailExpenseComponent implements OnInit {
  skLoading: boolean = false;
  expenseDetail: any = {};
  expenseId: any
  loader: any;
  travel: any = [];
  localConv: any = [];
  hotel: any = [];
  miscExp: any = [];
  food: any = [];
  savingFlag: boolean = false;
  assign_login_data: any = [];
  assign_login_data2: any = []
  expenseDetailRemark: any;
  url1: any='';
  selected_image: any = [];
  image = new FormData();
  errorMsg: boolean = false;

  constructor(public toast: ToastrManager, public route: ActivatedRoute, public navparams: ActivatedRoute, public serve: DatabaseService, public router: Router, public dialog: MatDialog, public alert: DialogComponent, public session: sessionStorage) {
    this.assign_login_data = this.session.getSession();
    this.assign_login_data = this.assign_login_data.value;
    this.assign_login_data2 = this.assign_login_data.data;
    this.assign_login_data = this.assign_login_data.assignModule;
    this.route.params.subscribe(params => {
      this.expenseId = params.id;
      this.serve.currentUserID = params.id
    });

    this.getExpenseDetail();
     let replaceUrl = ''
    replaceUrl = 'attendence/'
    this.url1 = this.serve.uploadUrl + replaceUrl;
    console.log(this.url1)

  }

  ngOnInit() { }

  openImage(url) {
    window.open(url);
  }

  back() {
    window.history.go(-1);
}

  getExpenseDetail() {
    this.loader = 1;
    this.skLoading = true;
    this.serve.post_rqst({ 'expenseId': this.expenseId }, "Expense/expenseDetail").subscribe(result => {
      if (result['statusCode'] == 200) {
        this.skLoading = false;
        this.expenseDetail = result['result'];
        this.expenseDetailRemark =  this.expenseDetail.btl[0].remark;
        this.travel = result['travel'];
        this.localConv = result['localConv'];
        this.hotel = result['hotel'];
        this.miscExp = result['miscExp'];
        this.food = result['food'];
      } else {
        this.skLoading = false;
        this.toast.errorToastr(result['statusMsg']);
      }
    }, err => {
      this.skLoading = false;
      this.toast.errorToastr('Something went wrong');
    })
  }
  calculateTotalKm() {
    const difference = this.info.close_km - this.info.start_km;
    this.info.total_km = difference >= 0 ? difference : 0;
  }
  info = {
    start_km: 0,
    close_km: 0,
    total_km: 0,
    data:{},
    selected_image:[],
    remark_type:''
  };

  updateExpense(){
    this.savingFlag = true;
     if(this.info.remark_type==''){
      this.savingFlag = false;
      return this.toast.errorToastr('Please select remark type');
    }else if(this.info.remark_type!='TA verified and found correct' && this.selected_image.length==0){
      this.savingFlag = false;
      return this.toast.errorToastr('Please upload image');
    }
   
    this.info.selected_image =this.selected_image
    this.info.data=this.expenseDetail
    console.log(this.info)
    this.serve.post_rqst(this.info, "Attendance/update_expense").subscribe((result => {

      if (result['statusCode'] == 200 ) {
        this.toast.successToastr(result['statusMsg']);  
        this.getExpenseDetail();


this.savingFlag = false;
this.info.start_km= 0,
    this.info.close_km= 0
    this.info.total_km= 0
    this.info.remark_type=''
    this.selected_image=[]

      }
      else {
          this.toast.errorToastr(result['statusMsg']);
          this.savingFlag = false;
      }

  }));
  }
  expModal(type, id, totalAmt) {
    const dialogRef = this.dialog.open(ExpenseModalComponent, {
      width: '400px',
      data: {
        type,
        id,
        from: 'expenseDetail',
        totalAmt,
        expenseType: this.expenseDetail.expenseType
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getExpenseDetail();

    });
  }


  imageModel(image) {
    const dialogRef = this.dialog.open(ImageModuleComponent, {
      panelClass: 'Image-modal',
      // width: '500px',
      data: {
        image,

      }
    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }
  delete(id,expenseId) {
    this.alert.delete('Expense!').then((result) => {
      if (result) {
        this.serve.post_rqst({ "id": id,"expenseId":expenseId }, "Expense/delete_local_expense").subscribe((result => {
          if (result['statusCode'] == 200) {
            this.toast.successToastr(result['statusMsg']);
            this.getExpenseDetail();
          }
          else {
            this.toast.errorToastr(result['statusMsg']);
          }

        }))
      }
    })

  }
  deleteExpenseImage(arrayIndex, id, name,expenseId) {

    
      this.serve.post_rqst({ 'image_id': id, 'image': name ,'expenseId':expenseId}, "Expense/expensemageDeleted").subscribe((result => {
        if (result['statusCode'] == '200') {
          this.toast.successToastr(result['statusMsg']);
          this.getExpenseDetail();
          // this.expenseDetail.expBills.splice(arrayIndex, 1);

        } else {
          this.toast.errorToastr(result['statusMsg']);
        }
      }
      ))
  
   


  }

   onUploadChange(data: any) {
      this.errorMsg = false;
      // this.image_id = '';
      for (let i = 0; i < data.target.files.length; i++) {
        let files = data.target.files[i];
        if (files) {
          let reader = new FileReader();
          reader.onload = (e: any) => {
              this.selected_image.push({ "image": e.target.result });
            
          }
          reader.readAsDataURL(files);
        }
        this.image.append("" + i, data.target.files[i], data.target.files[i].name);
      }
    }

    deleteImage(index) {
      this.selected_image.splice(index, 1);
    }

  openDialog(): void {
    const dialogRef = this.dialog.open(StatusModalComponent, {
      width: '1000px',
      panelClass: 'padding0',
      data: {
        'delivery_from': 'Expense',
        'expense_id':this.expenseId

      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != false) {
        this.getExpenseDetail();
      }
    });

  }

  goTo() {
    this.router.navigate(['/allowances', { from: 'expense-detail' }]);
  }


  edit_details(expense_type) {
    const dialogRef = this.dialog.open(ExpesneEditComponent, {
      width: expense_type == 'Travelentitlement' ? '950px' : '750px',
      data: {
        'from': 'expense detail page',
        'expense_type': expense_type,
        'expense_detail': expense_type == 'Travelentitlement' ? this.expenseDetail.travel :
          expense_type == 'hotel' ? this.expenseDetail.hotel :
            expense_type == 'food' ? this.expenseDetail.food :
              expense_type == 'local conveyance' ? this.expenseDetail.localConv :
                expense_type == 'misc expense information' ? this.expenseDetail.miscExp : 'no data found'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getExpenseDetail();
    });
  }
  print1() {

    const printContents = document.getElementById('print-section1').innerHTML;
    const originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
    setTimeout(() => {

      $('#print').hide();

    }, 1000);
  }
 goToImage(image) {
    const dialogRef = this.dialog.open(ImageModuleComponent, {
      panelClass: 'Image-modal',
      data: {
        'image': image,
        'type': 'base64'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
    });

  }
}
